import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { PersonalPropertyItem } from '../../generated/graphql';

interface PersonalPropertyItemSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'motionProps' | 'contentPrefix'
  > {
  itemTitle?: string;
  personalPropertyItem: PersonalPropertyItem;
  onItemClicked?: (a: { personalPropertyItem: PersonalPropertyItem }) => void;
}

export const PersonalPropertyItemSumTableItem = ({
  personalPropertyItem,
  onItemClicked,
  ...props
}: PersonalPropertyItemSumTableItemProps) => {
  return (
    <AmountSumTableItem
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      key={personalPropertyItem.id}
      title={props.itemTitle ?? personalPropertyItem.name}
      dataTestID={personalPropertyItem.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      amount={personalPropertyItem.ownedValue}
      className={props.className}
      onClick={() => onItemClicked?.({ personalPropertyItem })}
      lastUpdated={latestDataPointGroupUpdateDateTime(personalPropertyItem.value)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ personalPropertyItem })}
      decayed={isDecayed(latestDataPointGroupUpdateDate(personalPropertyItem.value), decayedLimit.PersonalPropertyItem)}
      {...props}
    />
  );
};
